import React from "react";
import { Form, Popover, Modal,message, Tooltip } from "antd";
import classNames from "classnames";
import { connect } from "react-redux";
import {translate} from "$ACTIONS/Translate";
import { getE2BBValue } from "$ACTIONS/helper";
import {
    TransferSubmit,
    GetAllBalance,
} from "$DATA/wallet";
import { formatAmount } from "../../../actions/util";
import { GetAllBalanceV2 } from "../../../data/wallet";
import { userCenterActions } from "../../../store/userCenterSlice";
class HeadBlance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
            isSuccess:"",
            TotalBal:"",
            MAINBal:"",
            otherWalletTotal:0,
            balanceList: [],
        };
    }
    componentDidMount() {
        this.getAllBalance();
    }
    componentWillUnmount(){
        this.setState =()=> false
    }
    getAllBalance= () => {
        // this.props.setLoading(true);
        GetAllBalanceV2((res) => {
            console.log("GetAllBalanceV2",res);
                this.setState(
                    {
                        balanceList: res?.result,
                        TotalBal: res?.result?.totalBalance,
                        MAINBal: res?.result?.balances?.find((v) => v.walletProductGroupId == 1),
                        balanceInfo: res?.result,
                    }
                );
            // this.props.setLoading(false);
        });
    }
    handleTransfer= (TotalBal)=> {
        this.props.setLoading(true);
        let DATA = {
            fromAccount: "ALL",
            toAccount: "MAIN",
            amount: TotalBal,
            blackBoxValue: getE2BBValue(),
            e2BlackBoxValue: getE2BBValue(),
        };
        TransferSubmit(DATA, (res) => {
            this.props.setLoading(false);
            if (res.isSuccess && res.result) {
                if (res.result.status == 1) {
                    this.getAllBalance();
                    message.success(translate("转账成功"));
                }
                else{
                    message.error(translate("转账失败"));
                }
            } else {
                message.error(translate("转账失败"));
            }
        });
    }
    render() {
        const {
            balanceList,
            otherWalletTotal,
            TotalBal,
            MAINBal,
            showAll
        } = this.state;

        return (
            <React.Fragment>
                <div>
                    <div className="MainBlance" style={{ display: "block" }}>
                        {this.props.toggleOnOff ? (
                            <div
                                className="item-blance"
                                style={{
                                    width: "100%",
                                }}
                                flex="1"
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <div>Số dư hiện có thể rút</div>
                                    <b
                                        style={{
                                            paddingRight: "12px",
                                            color: "#222222",
                                        }}
                                    >
                                        {formatAmount(
                                            this.state.balanceInfo
                                                ?.withdrawableBalance
                                        ) || "0"}{" "}
                                        đ
                                    </b>
                                </div>
                                <div
                                    style={{
                                        color: "#999999",
                                        fontSize: "10px",
                                        lineHeight: "12px",
                                        margin: "10px 0px",
                                    }}
                                >
                                    (Giao dịch rút tiền sẽ được cập nhật trong
                                    vòng 15 phút sau khi cược được đặt)
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: "center",
                                }}
                            >
                                <div>Tổng Số Dư</div>
                                <div>
                                    <b>
                                        {formatAmount(
                                            this.state.balanceInfo?.totalBalance
                                        )}{" "}
                                        đ
                                    </b>
                                </div>
                            </div>
                        )}
                        {this.props.toggleOnOff && (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: "center",
                                }}
                                onClick={() => {
                                    Pushgtagdata(
                                        "Withdrawal",
                                        "Go to Locked Balance",
                                        "Withdrawal_C_LockedBalance"
                                    );
                                    this.props?.onCancel() &&
                                        this.props?.onCancel();
                                    this.props.setLockBalanceModal(true);
                                }}
                            >
                                <div
                                    style={{
                                        color: "#666666",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                    }}
                                >
                                    Tiền doanh thu chưa hoàn thành
                                    <Tooltip
                                        overlayClassName={"tooltip-dark"}
                                        placement="bottom"
                                        title={
                                            "Hoàn thành các yêu cầu doanh thu để mở khóa số tiền nạp đủ điều kiện và số tiền thưởng thành số tiền có thể rút."
                                        }
                                    >
                                        <span
                                            style={{
                                                marginLeft: "5px",
                                            }}
                                        >
                                            <img
                                                src="/vn/img/1wallet/00/lock.svg"
                                                alt="Lock"
                                            />
                                        </span>
                                    </Tooltip>
                                </div>
                                <b style={{ color: "#222222" }}>
                                    {formatAmount(
                                        this.state.balanceInfo
                                            ?.totalContractBalance
                                    ) || "0"}{" "}
                                    đ
                                    <span
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            cursor: "pointer",
                                            marginLeft: "5px",
                                        }}
                                    >
                                        <img
                                            src="/vn/img/1wallet/00/arw3.svg"
                                            alt="ArrowRight"
                                        />
                                    </span>
                                </b>
                            </div>
                        )}
                    </div>
                    {/* <div className="card-balance-wrap" style={{ display: showAll ? 'block' : 'none' }}>
                        {balanceList && balanceList.length ? (
                            balanceList.map((val, index) => {
                                if (val.category === 'Main' || val.category === 'TotalBal') return null;
                                return (
                                    <div className="balance-box" key={'walletTransfer' + index} onClick={() => {}}>
                                        <div>
                                            <span>{val.localizedName}</span>
                                            {val.name === 'SB' ? (
                                                <Popover
                                                    overlayStyle={{ zIndex: 1000 }}
                                                    align={{ offset: [ -4, 0 ] }}
                                                    placement="bottomLeft"
                                                    overlayClassName="popover-dark"
                                                    content={<div>包含 醉心体育, V2虚拟体育, 沙巴体育, BTI 体育, IM 体育和电竞</div>}
                                                    title=""
                                                    trigger="hover"
                                                >
                                                    <span className="header-popover-inner-tip pointer">
                                                        <Icon type="question-circle" />
                                                    </span>
                                                </Popover>
                                            ) : null}
                                        </div>
                                        <div>{val.state === 'UnderMaintenance' ? '维护中' : '￥' + val.balance}</div>
                                        <div className="btn" />
                                    </div>
                                );
                            })
                        ) : null}
                    </div> */}
                </div>
                <Modal
                    title={translate(`其他钱包`)}
                    className="modal-pubilc BalanceList"
                    visible={showAll}
                    closable={true}
                    centered={true}
                    width={400}
                    footer={null}
                    zIndex={1500}
                    onCancel={() => {
                        this.setState({
                            showAll: false,
                        });
                    }}
                >
                    <div className="Content">
                        {balanceList && balanceList.length
                            ? balanceList.map((val, index) => {
                                  if (
                                      val.category === "Main" ||
                                      val.category === "TotalBal"
                                  )
                                      return null;
                                  return (
                                      <div
                                          key={"walletTransfer" + index}
                                          className={classNames({
                                              "balance-box": true,
                                              UnderMaintenance:
                                                  val.state ==
                                                  "UnderMaintenance",
                                          })}
                                      >
                                          <div>
                                              <span className="localizedName">
                                                  {val.localizedName}
                                              </span>
                                              {/* {val.name === "SB" ? (
                                                <Popover
                                                    overlayStyle={{
                                                        zIndex: 1000,
                                                    }}
                                                    align={{ offset: [-4, 0] }}
                                                    placement="bottomLeft"
                                                    overlayClassName="popover-dark"
                                                    content={
                                                        <div>
                                                            包含 V2虚拟体育,
                                                            沙巴体育, BTI 体育, IM
                                                            体育和电竞
                                                        </div>
                                                    }
                                                    title=""
                                                    trigger="hover"
                                                >
                                                    <span className="header-popover-inner-tip pointer">
                                                        <img src={`${process.env.BASE_PATH}/img/icon/note.svg`} />
                                                    </span>
                                                </Popover>
                                            ) : null} */}
                                              {/* {val.name === "P2P" ? (
                                                <Popover
                                                    overlayStyle={{
                                                        zIndex: 1000,
                                                    }}
                                                    align={{ offset: [-4, 0] }}
                                                    placement="bottomLeft"
                                                    overlayClassName="popover-dark"
                                                    content={
                                                        <div>
                                                            包含双赢棋牌，开元棋牌和小游戏​
                                                        </div>
                                                    }
                                                    title=""
                                                    trigger="hover"
                                                >
                                                    <span className="header-popover-inner-tip pointer">
                                                        <img src="/vn/img/icon/note.svg" />
                                                    </span>
                                                </Popover>
                                            ) : null} */}
                                          </div>
                                          <div className="num">
                                              {val.state === "UnderMaintenance"
                                                  ? translate("维护中")
                                                  : val.balance + " đ"}
                                          </div>
                                          <div className="btn" />
                                      </div>
                                  );
                              })
                            : null}
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default HeadBlance;
